import { MarketDetailsContainer } from '@/features/market-details/MarketDetailsContainer'

export function MarketDetails() {
  return <MarketDetailsContainer />
}
